module.exports = __webpack_public_path__ + "static/media/helps.9bc2192e.svg";